import React, { useState, useEffect, useMemo } from "react";
import { Ptag, OverlayLoader, IfComponent, Chip } from "components/core";
import { formatDateSequence, newFormatRupees, roleIsAdmin } from "utlis/utils";
import { TopHeader, Icon, Table } from "../../GmcPaymentSummary/styles";
import EditIcon from "assets/svgs/edit.svg";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { capitalize } from "lodash";
import { Button, Tooltip } from "@mui/material";
import EmptyDataLottie from "components/EmptyDataLottie";
import BaseNewDropDown from "components/core/BaseNewDropDown";
import NewDateStandardInput from "components/UniversalComponents/NewDateStandardInput";
import filterByDateRangeAndProducts from "pages/GmcPaymentSummary/utils";
import PaymentDocumentModal from "pages/GmcPaymentSummary/PaymentDocumentModal";
import { ENROLMENT_HISTORY_COLUMNS } from "constants";
import { FilterContainer } from "./styles";
import useFetchEnrolment from "./useFetchEnrolment";
import useUser from "hooks/useUser";

const EnrolmentHistory = () => {
  const [overallData, setOverallData] = useState();
  const [tableData, setTableData] = useState();
  const [products, setProducts] = useState([]);
  const [dateRangeFrom, setDateRangeFrom] = useState();
  const [dateRangeTo, setDateRangeTo] = useState();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [transactionDate, setTransactionDate] = useState();

  const navigate = useNavigate();

  const { loading, enrolments } = useFetchEnrolment();

  const { getRole } = useUser();
  const role = getRole();

  const showEditButton = useMemo(() => {
    return role == "admin";
  }, [role]);

  useEffect(() => {
    if (enrolments) {
      setOverallData(enrolments);
      setTableData(enrolments);
      const productArray = enrolments.reduce((acc, item) => {
        if (!acc.includes(item.product)) acc.push(item.product);
        return acc;
      }, []);
      setProducts(productArray);
    }
  }, [enrolments]);

  const tableHeaders = useMemo(() => {
    const permittedColumns = ENROLMENT_HISTORY_COLUMNS.filter((enr) => {
      console.log({ enr });
      if (role == "admin" && enr === "") return true;
      return true;
    });
    return permittedColumns.map((title) => (
      <th
        style={{
          padding: "2rem 0rem",
          width: title === "Payment Amount" ? "300px" : "200px",
          verticalAlign: "text-top",
          textAlign: "center",
        }}
      >
        <TopHeader
          style={{
            flexDirection: "column",
            padding: "0px 12px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Ptag
            fontSize="14px"
            textAlign="center"
            color="#002060"
            fontWeight="600"
          >
            {title}
          </Ptag>
          {["Total Employees", "Total Lives"].includes(title) && (
            <Ptag
              fontSize="10px"
              textAlign="center"
              color="#686666"
              fontWeight="400"
              marginTop="4px"
            >
              (Addition/Deletion)
            </Ptag>
          )}
        </TopHeader>
      </th>
    ));
  }, [role]);

  const renderChip = (number, addition) => {
    if (number <= 0) return;
    let bgColor = addition ? "#ECFDF3" : "#FEF3F2";
    let color = addition ? "#027A48" : "#B42318";
    let symbol = addition ? <AddIcon /> : <RemoveIcon />;

    return (
      <Chip
        style={{
          marginLeft: !addition ? "1rem" : "0rem",
          borderRadius: "11px",
        }}
        text={
          <span style={{ color, display: "flex", alignItems: "center" }}>
            {symbol} {number}
          </span>
        }
        background={bgColor}
      />
    );
  };

  const getTotalAmount = (value) => {
    var total_amount =
      (value.cgst || 0) +
      (value.igst || 0) +
      (value.sgst || 0) +
      (value.net_premium || 0);
    if(total_amount === 0) return "-";
    if(total_amount < 0) {
      const formatted = newFormatRupees(Math.abs(total_amount));
      return `- ${formatted}`;
    }
    return newFormatRupees(total_amount);
  };
  const extractFilteredData = () => {
    const filteredData = filterByDateRangeAndProducts(
      overallData,
      [dateRangeFrom, dateRangeTo],
      selectedProducts
    );
    setTableData(filteredData);
  };
  const clearValues = () => {
    setDateRangeFrom();
    setDateRangeTo();
    setSelectedProducts([]);
    setTableData(overallData);
  };
  const openModal = (documents, date, wellnessInvoices) => {
    let filenames = Object.values(documents).filter((link) => {
      return link !== null;
    });
    if(wellnessInvoices && wellnessInvoices.length > 0) {
      const preLinks = wellnessInvoices.map((inv) => {
        if(typeof inv == "string") {
          return inv;
        }
        return inv.link
      });
      filenames = [...filenames, ...preLinks]
    }
    setOpen(true);
    setDocuments(filenames);
    setTransactionDate(date);
  };
  const redirectToEdit = (data) => {
    navigate("/v1/enrolments/edit", { state: data });
  };

  const textColorHandler = (value) => {
    // if(value === "PENDING") {
    //   return <Ptag fontSize="14px" fontWeight="500">{capitalize(value)}</Ptag>
    // } else 
    if (value === "ACTIVATED") {
      return <Ptag fontSize="14px" color="green">{capitalize(value)}</Ptag>
    } else {
      return capitalize(value);
    }
  }

  const productHandler = (product) => {
    if(product === "Group Parental Cover") { // Needed! as mapping done in constants is incorrect!
      return "Parental Cover"
    } return product
  }

  const statusViewHandler = (value, orderId, userPlanId, product) => {
    if (roleIsAdmin() && value === "PENDING") {
      return (
        <Link
          to={`create?orderId=${orderId}&userPlanId=${userPlanId}&product=${productHandler(product)}`}
          style={{
            whiteSpace: "nowrap",
            fontSize: "13px",
            color: "#2354D4",
            letterSpacing: 0,
            cursor: "pointer",
            fontFamily: "Inter",
            textDecoration: "underline",
          }}
        >
          Upload UHID
        </Link>
      );
    } else {
      return textColorHandler(value)
    }
  };

  const renderPaymentSummery = () => {
    return (
      <div style={{ position: "relative" }}>
        <PaymentDocumentModal
          onOpen={open}
          documents={documents}
          handleOpen={setOpen}
          transactionDate={transactionDate}
        />
        {overallData && overallData.length > 0 ? (
          <IfComponent condition={tableData && tableData.length >= 0}>
            <div style={{ overflow: "auto" }}>
              <FilterContainer>
                <div>
                  <Ptag
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(87, 95, 110, 1)"
                    marginBottom="-4px"
                  >
                    Products
                  </Ptag>
                  <BaseNewDropDown
                    label="Select Products"
                    options={products}
                    values={selectedProducts}
                    onChange={setSelectedProducts}
                    withCheckboxes={true}
                  />
                </div>

                <div>
                  <Ptag
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(87, 95, 110, 1)"
                    marginBottom="-4px"
                  >
                    Payment Date
                  </Ptag>
                  <NewDateStandardInput
                    label="From"
                    value={dateRangeFrom}
                    onChange={setDateRangeFrom}
                    maxDate={dateRangeTo}
                  />
                </div>

                <div>
                  <NewDateStandardInput
                    label="To"
                    value={dateRangeTo}
                    onChange={setDateRangeTo}
                    minDate={dateRangeFrom}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    gridColumn: "span 1",
                    justifyContent: "flex-start",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={clearValues}
                    sx={clearButtonStyles}
                  >
                    Clear
                  </Button>

                  <Button
                    variant="contained"
                    onClick={extractFilteredData}
                    sx={applyButtonStyles}
                  >
                    Apply
                  </Button>
                </div>
              </FilterContainer>
             <Table
  id="table-to-xls"
  className="table-striped"
  width="100%"
  cellSpacing="0"
  cellPadding="6"
  showBottomBorder={tableData && tableData.length !== 1}
>
  <tbody>
    <tr style={{ backgroundColor: "#E5E2EF" }}>{tableHeaders}</tr>
    {tableData &&
      tableData.map((payment_data, index) => {
        const isLastRow = index === tableData.length - 1;
        const cellStyle = isLastRow ? { borderBottom: "none" } : {};

        return (
          <tr key={index} style={{ background: "white" }}>
            <td style={cellStyle}>
              <TopHeader style={{ justifyContent: "flex-start" }}>
                <Ptag fontSize="14px" color="#4A4A4A" marginLeft="22px">
                  {payment_data.product}
                </Ptag>
              </TopHeader>
            </td>
            <td style={cellStyle}>
              <TopHeader>
                <Ptag fontSize="14px" color="#4A4A4A">
                  {payment_data.type ? capitalize(payment_data.type) : "-"}
                </Ptag>
              </TopHeader>
            </td>
            <td style={cellStyle}>
              <TopHeader>
                <Ptag fontSize="14px" color="#4A4A4A" marginLeft="22px">
                  {statusViewHandler(
                    payment_data.status,
                    payment_data.order_id,
                    payment_data.userplan_id,
                    payment_data.product
                  )}
                </Ptag>
              </TopHeader>
            </td>
            <td style={cellStyle}>
              <TopHeader>
                {Number(payment_data.no_of_employees_added) ||
                Number(payment_data.no_of_employees_deleted) ? (
                  <>
                    {renderChip(payment_data.no_of_employees_added || 0, true)}
                    {renderChip(payment_data.no_of_employees_deleted || 0)}
                  </>
                ) : (
                  <Ptag fontSize="16px">-</Ptag>
                )}
              </TopHeader>
            </td>
            <td style={cellStyle}>
              <TopHeader>
                {Number(payment_data.no_of_lives_added) ||
                Number(payment_data.no_of_lives_deleted) ? (
                  <>
                    {renderChip(payment_data.no_of_lives_added || 0, true)}
                    {renderChip(payment_data.no_of_lives_deleted || 0)}
                  </>
                ) : (
                  <Ptag fontSize="16px">-</Ptag>
                )}
              </TopHeader>
            </td>
            <td style={cellStyle}>
              <TopHeader>
                <Ptag fontSize="14px" color="#4A4A4A">
                  {(payment_data.transaction_date &&
                    formatDateSequence(payment_data.transaction_date)) ||
                    "-"}
                </Ptag>
              </TopHeader>
            </td>
            <td style={{ ...cellStyle, width: "200px" }}>
              <TopHeader style={{ justifyContent: "center" }}>
                <Ptag fontSize="14px" color="#4A4A4A" textAlign="center">
                  {getTotalAmount(payment_data)}
                </Ptag>
              </TopHeader>
            </td>
            <td style={cellStyle}>
              <TopHeader>
                {payment_data.endorsement_number ? (
                  <Tooltip
                    arrow
                    title={<Ptag color="white">{payment_data.endorsement_number}</Ptag>}
                    style={{
                      fontSize: "14px !important",
                    }}
                  >
                    <Ptag
                      fontSize="14px"
                      className="truncate-hover"
                      textAlign="center"
                      color="#4a4a4a"
                    >
                      {payment_data.endorsement_number || "-"}
                    </Ptag>
                  </Tooltip>
                ) : (
                  "-"
                )}
              </TopHeader>
            </td>
            <td style={cellStyle}>
              <TopHeader style={{ gap: "0.8rem", justifyContent: "center" }}>
                <Ptag
                  style={{
                    fontSize: "13px",
                    color: "#2354D4",
                    letterSpacing: 0,
                    cursor: "pointer",
                    fontFamily: "Inter",
                    textDecoration: "underline",
                  }}
                  onClick={() =>
                    openModal(
                      payment_data.documents,
                      payment_data?.transaction_date,
                      payment_data?.invoice_link_list
                    )
                  }
                >
                  View
                </Ptag>
              </TopHeader>
            </td>
            <td style={cellStyle}>
              {showEditButton && (
                <TopHeader onClick={() => redirectToEdit(payment_data)} style={{ cursor: "pointer" }}>
                  <Icon src={EditIcon} />
                </TopHeader>
              )}
            </td>
          </tr>
        );
      })}
  </tbody>
</Table>

            </div>
          </IfComponent>
        ) : (
          <EmptyDataLottie text="No Data Availble" />
        )}
      </div>
    );
  };

  return <>{loading ? <OverlayLoader /> : renderPaymentSummery()}</>;
};

export default EnrolmentHistory;

const buttonStyles = {
  fontSize: "14px",
  textTransform: "none",
  border: "1px solid",
  height: "40px",
  boxShadow: "none",
};

const clearButtonStyles = {
  ...buttonStyles,
  backgroundColor: "white",
  color: "rgba(34, 27, 60, 1)",
  padding: "0px 36px",
  "&:hover": {
    backgroundColor: "white",
    boxShadow: "none",
  },
};

const applyButtonStyles = {
  ...buttonStyles,
  color: "rgba(228, 219, 255, 1)",
  padding: "0px 36px",
  backgroundColor: "rgba(34, 27, 60, 1)",
  "&:hover": {
    backgroundColor: "rgba(34, 27, 60, 1)",
    boxShadow: "none",
  },
};
